const PUBLIC_API = import.meta.env.VITE_PUBLIC_API_URL as string;

export function passbookLogoUrl(passbookId: string): string {
  return `${PUBLIC_API}/${passbookId}/logo.png`;
}
